import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_OrganizationPermission, DBDef_OrganizationPermission, OrganizationPermissionsPermissionKeys } from '@app/org-permissions-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { MUSTNeverHappenException, RuntimeModules } from '@nu-art/ts-common';
import { OrgAccessLevel } from '@app/hcs-shared';
import { SessionKeyFE_OrganizationPermission } from '../../consts.js';
export const dispatch_onOrganizationChanged = new ThunderDispatcherV3('__onOrganizationPermissionUpdated');
export class ModuleFE_OrganizationPermission_Class extends ModuleFE_BaseApi {
    _v1;
    permissions;
    constructor() {
        super(DBDef_OrganizationPermission, dispatch_onOrganizationChanged);
        this._v1 = {
            changeOrganizationOwnership: apiWithBody(ApiDef_OrganizationPermission._v1.changeOrganizationOwnership, async (response, request) => {
                const parsedRequest = JSON.parse(request);
                const dbModule = RuntimeModules().find(module => {
                    const dbDef = module?.dbDef;
                    if (!dbDef)
                        return false;
                    return dbDef?.dbKey === parsedRequest.collectionName;
                });
                if (!dbModule)
                    throw new MUSTNeverHappenException(`cannot find db module for key ${request.collectionName}`);
                await dbModule.onEntryUpdated(response, parsedRequest.instance);
            }),
        };
        this.permissions = {
            ui: {},
            collection: PermissionKey_FE.generatePermissionKeysByLevels(OrganizationPermissionsPermissionKeys)
        };
    }
    init() {
        super.init();
    }
    /**
     * Assert access level by org per object, pass in current object to assert the user access level by organization
     * @param item The current DB item to assert permissions to
     */
    getOrgPermissionLevel = (item) => {
        const orgSessionData = SessionKeyFE_OrganizationPermission.get();
        // assert write
        if (orgSessionData.writeAccessLevels?.includes(item.meta.write[0]))
            return OrgAccessLevel.write;
        // assert read permission. TODO: verify this assertion
        if (orgSessionData.readAccessLevels?.includes(item.meta.read[0]))
            return OrgAccessLevel.read;
        // return read, if the user can see this object he has read permission for this object
        return OrgAccessLevel.noAccess;
    };
}
export const ModuleFE_OrganizationPermission = new ModuleFE_OrganizationPermission_Class();
//# sourceMappingURL=ModuleFE_OrganizationPermission.js.map